export enum ReceiptStateValue {
  disabled = 'disabled',
  new = 'new',
  pending = 'pending',
  rejected = 'rejected',
  success = 'success',
  limit = 'limit',
}

export interface ReceiptState {
  source: {
    web: {
      upload_allowed: boolean;
      state: ReceiptStateValue;
    };
    link: {
      upload_allowed: boolean;
      state: ReceiptStateValue;
    };
  };
  history: ReceiptHistory[];
}

export interface ReceiptHistory {
  comment: null | string;
  download_url: string;
  id: string;
  status: ReceiptStateValue;
  uploaded_at: string;
}
